module.exports = __webpack_public_path__ + "efd04a230602572c6809cce22100df0d.svg";